function hideUpsale() {
	var wrapper = document.querySelector(".pp-upsale-cart");

	wrapper.classList.add('pp-hide');
	wrapper.style.display = 'none';
}

function hideUpsaleCartPage() {
	var wrapper = document.querySelector(".pp-upsale-page");
	wrapper.classList.add('pp-hide');
	wrapper.style.display = 'none';
}

function prepareWrapper(wrapper, productInCart) {
	if(wrapper == undefined) {
		return;
	}

	if (productInCart){
		wrapper.classList.add('pp-hide');
		wrapper.style.display = 'none';
		return;
	  } else {
		wrapper.classList.remove('pp-hide');
		wrapper.style.display = 'block';
	  }
}

function addToCardPP(id, productInCart) {
	const drawerWrapper = document.querySelector(".pp-upsale-cart");
	const pageWrapper = document.querySelector(".pp-upsale-page");

	prepareWrapper(drawerWrapper, productInCart);
	prepareWrapper(pageWrapper, productInCart);

  	handleFetch(id, drawerWrapper, pageWrapper);
}

function handleFetch(id, drawerWrapper, pageWrapper) {
	var cartbubble = document.getElementsByClassName("cart-count-bubble");
	fetch("/cart/add.js", {
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
		body: "id=" + id,
	})
		.then((response) => response.json())
		.then((data) => {
			publish(PUB_SUB_EVENTS.cartUpdate, {
				source: "cart-items-pp",
				cartData: data,
				variantId: id,
			});
			cartbubble[0].childNodes[0].textContent =
				parseInt(cartbubble[0].childNodes[0].textContent) + 1;
			if (drawerWrapper) {
				drawerWrapper.classList.add('pp-hide');
			}
			if (pageWrapper) {
				pageWrapper.classList.add('pp-hide');
			}
			setTimeout(() => {
				if (drawerWrapper) {
					drawerWrapper.style.display = 'none';
				}
				if (pageWrapper) {
					pageWrapper.style.display = 'none';
				}
			}, 300);
			const totalPriceElement = document.querySelector(".cart__footer .totals__total-value");
			if (totalPriceElement) {
				fetch("/cart.js", { method: "GET" })
					.then((response) => response.json())
					.then((cart) => {
						const totalPrice = (cart.total_price / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });;
						const totalPriceString = '€' + totalPrice.replace("€", "EUR");
						totalPriceElement.textContent = totalPriceString;
					});
			}
			
		})
		.catch((error) => {
			console.error(
				"Fehler beim Hinzufügen des Produkts in den Warenkorb:",
				error
			);
		});
}

function addToCardFetch(id){
	var cartbubble = document.getElementsByClassName("cart-count-bubble");
	fetch("/cart/add.js", {
		method: "POST",
		headers: {
		  "Content-Type": "application/x-www-form-urlencoded",
		},
		body: "id=" + id,
	  })
		.then((response) => response.json())
		.then((data) => {
		  publish(PUB_SUB_EVENTS.cartUpdate, {
			source: "cart-items-pp",
			cartData: data,
			variantId: id,
		  });
		  //cartbubble[0].childNodes[0].textContent = parseInt(cartbubble[0].childNodes[0].textContent) + 1;
		})
		.catch((error) => {
		  console.error(
			"Fehler beim Hinzufügen des Produkts in den Warenkorb:",
			error
		  );
		});
}
